// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3mD2M","filesListContainer":"PosDisputesFiles_filesListContainer__rFtkC","filesButton":"PosDisputesFiles_filesButton__3-HTv"};